import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import {
  AutoCompleteRemoto,
  TextInput,
  SelectInput,
} from '../../../Components';
import useDebounceCustom from '../../../hooks/useDebounce';
import { api, getListAPI } from '../../../services';
import {
  STATUS_ATIVO,
  TURNO_MANHA,
  ESTADO_FISICO_CONGELADO,
  ESTADO_FISICO_RESFRIADO,
  ESTADO_FISICO_SECO,
} from '../../../utils';

const optionsEstadoFisico = [
  { label: 'Congelado', value: ESTADO_FISICO_CONGELADO },
  { label: 'Resfriado', value: ESTADO_FISICO_RESFRIADO },
  { label: 'Seco', value: ESTADO_FISICO_SECO },
];

const FILTROS_DISPONIVEIS = [
  { key: 'categoria', label: 'Categoria' },
  { key: 'familia', label: 'Família' },
  { key: 'local', label: 'Local/Setor' },
  { key: 'fornecedor', label: 'Fornecedor' },
  { key: 'unidade', label: 'Unidade' },
  { key: 'estadoFisico', label: 'Estado Físico' },
  { key: 'codigo', label: 'Código de barras' },
];

const PRODUTOS_PER_PAGE = 20;

const SELECAO_NENHUM = 'nenhum';
const SELECAO_TODOS = 'todos';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DialogoDistribuirProdutos = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [categoria, setCategoria] = useState(null);
  const [nome, setNome] = useState('');
  const [nomeDebounce] = useDebounceCustom(nome, 500);
  const [codigo, setCodigo] = useState('');
  const [codigoDebounce] = useDebounceCustom(codigo, 500);
  const [familia, setFamilia] = useState(null);
  const [local, setLocal] = useState(null);
  const [fornecedor, setFornecedor] = useState(null);
  const [unidade, setUnidade] = useState(null);
  const [estadoFisico, setEstadoFisico] = useState('');

  const [filtrosAtivos, setFiltrosAtivos] = useState([]);
  const [anchorElFiltro, setAnchorElFiltro] = useState(null);

  const [codinome, setCodinome] = useState(null);

  const [produtos, setProdutos] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  const [modoSelecao, setModoSelecao] = useState(SELECAO_NENHUM);
  const [excecoes, setExcecoes] = useState(new Set());

  const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);

  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  function reiniciar() {
    setCategoria(null);
    setNome('');
    setCodigo('');
    setFamilia(null);
    setLocal(null);
    setFornecedor(null);
    setUnidade(null);
    setEstadoFisico('');
    setFiltrosAtivos([]);
    setAnchorElFiltro(null);
    setCodinome(null);
    setProdutos([]);
    setTotal(0);
    setPage(0);
    setModoSelecao(SELECAO_NENHUM);
    setExcecoes(new Set());
    setConfirmacaoAberta(false);
    setSalvando(false);
  }

  const limparFiltro = {
    categoria: () => setCategoria(null),
    familia: () => setFamilia(null),
    local: () => setLocal(null),
    fornecedor: () => setFornecedor(null),
    unidade: () => setUnidade(null),
    estadoFisico: () => setEstadoFisico(''),
    codigo: () => setCodigo(''),
  };

  function adicionarFiltro(key) {
    setFiltrosAtivos((atuais) => [...atuais, key]);
    setAnchorElFiltro(null);
  }

  function removerFiltro(key) {
    setFiltrosAtivos((atuais) => atuais.filter((item) => item !== key));
    limparFiltro[key]();
  }

  async function carregarProdutos(paginaAlvo = page) {
    setCarregando(true);
    try {
      const filter = {};
      if (categoria) filter.categoria_id = categoria.id;
      if (nomeDebounce) filter.nome = nomeDebounce;
      if (codigoDebounce) filter.codigo = codigoDebounce;
      if (familia) filter.familia_produto_id = familia.id;
      if (local) filter.local_id = local.id;
      if (fornecedor) filter.fornecedor_id = fornecedor.id;
      if (unidade) filter.unidade_id = unidade.id;
      if (estadoFisico) filter.estado_fisico = estadoFisico;

      const response = await getListAPI(
        'produtos/search/sem_codinome',
        ['id', 'asc'],
        [paginaAlvo + 1, PRODUTOS_PER_PAGE],
        filter,
        [],
      );

      setProdutos(response.data);
      setTotal(response.total);
    } catch (erros) {
      enqueueSnackbar(`${erros}`, { variant: 'error' });
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    if (open) carregarProdutos();
  }, [
    open,
    page,
    categoria,
    nomeDebounce,
    codigoDebounce,
    familia,
    local,
    fornecedor,
    unidade,
    estadoFisico,
  ]);

  useEffect(() => {
    if (open) {
      setPage(0);
      setModoSelecao(SELECAO_NENHUM);
      setExcecoes(new Set());
    }
  }, [
    categoria,
    nomeDebounce,
    codigoDebounce,
    familia,
    local,
    fornecedor,
    unidade,
    estadoFisico,
  ]);

  useImperativeHandle(ref, () => ({
    handleOpen() {
      reiniciar();
      setOpen(true);
    },
  }));

  function isProdutoSelecionado(id) {
    return modoSelecao === SELECAO_TODOS ? !excecoes.has(id) : excecoes.has(id);
  }

  function toggleProduto(id) {
    setExcecoes((atuais) => {
      const novas = new Set(atuais);
      if (novas.has(id)) novas.delete(id);
      else novas.add(id);
      return novas;
    });
  }

  const totalSelecionados =
    modoSelecao === SELECAO_TODOS
      ? Math.max(total - excecoes.size, 0)
      : excecoes.size;

  function selecionarTodos() {
    setModoSelecao(SELECAO_TODOS);
    setExcecoes(new Set());
  }

  function desmarcarTodos() {
    setModoSelecao(SELECAO_NENHUM);
    setExcecoes(new Set());
  }

  const idsPagina = produtos.map((produto) => produto.id);
  const todosSelecionadosNaPagina =
    idsPagina.length > 0 && idsPagina.every((id) => isProdutoSelecionado(id));

  function toggleTodosDaPagina() {
    const novoEstado = !todosSelecionadosNaPagina;
    setExcecoes((atuais) => {
      const novas = new Set(atuais);
      idsPagina.forEach((id) => {
        const deveEstarNasExcecoes =
          modoSelecao === SELECAO_TODOS ? !novoEstado : novoEstado;
        if (deveEstarNasExcecoes) novas.add(id);
        else novas.delete(id);
      });
      return novas;
    });
  }

  function renderCampoFiltro(key) {
    switch (key) {
      case 'categoria':
        return (
          <AutoCompleteRemoto
            label="Categoria"
            value={categoria}
            onChange={(value) => setCategoria(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="categorias"
            nested={[]}
            filters={{}}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'familia':
        return (
          <AutoCompleteRemoto
            label="Família"
            value={familia}
            onChange={(value) => setFamilia(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="familias_produtos"
            nested={[]}
            filters={{}}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'local':
        return (
          <AutoCompleteRemoto
            label="Local/Setor"
            value={local}
            onChange={(value) => setLocal(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="locais_setores"
            nested={[]}
            filters={{ status: STATUS_ATIVO }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'fornecedor':
        return (
          <AutoCompleteRemoto
            label="Fornecedor"
            value={fornecedor}
            onChange={(value) => setFornecedor(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="fornecedores"
            nested={[]}
            filters={{ status: STATUS_ATIVO }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'unidade':
        return (
          <AutoCompleteRemoto
            label="Unidade"
            value={unidade}
            onChange={(value) => setUnidade(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="unidades"
            nested={[]}
            filters={{ status: STATUS_ATIVO }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'estadoFisico':
        return (
          <FormControl variant="outlined" fullWidth>
            <InputLabel shrink id="estado-fisico-distribuir-produtos">
              Estado Físico
            </InputLabel>
            <SelectInput
              labelId="estado-fisico-distribuir-produtos"
              label="Estado Físico"
              handleEnter={() => {}}
              handleKey={() => {}}
              value={estadoFisico}
              onChange={(event) => setEstadoFisico(event.target.value)}
              options={[{ label: 'Todos', value: '' }, ...optionsEstadoFisico]}
            />
          </FormControl>
        );
      case 'codigo':
        return (
          <TextInput
            label="Código de barras"
            value={codigo}
            onChange={(event) => setCodigo(event.target.value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            fullWidth
            margin="none"
          />
        );
      default:
        return null;
    }
  }

  async function handleConfirmarAtribuir() {
    if (!codinome) return;
    setSalvando(true);
    try {
      const body = {
        categoria_id: categoria ? categoria.id : null,
        nome: nomeDebounce || null,
        codigo: codigoDebounce || null,
        familia_produto_id: familia ? familia.id : null,
        local_id: local ? local.id : null,
        fornecedor_id: fornecedor ? fornecedor.id : null,
        unidade_id: unidade ? unidade.id : null,
        estado_fisico: estadoFisico || null,
      };

      if (modoSelecao === SELECAO_TODOS) {
        body.produtos_id_excluidos = Array.from(excecoes);
      } else {
        body.produtos_id_incluidos = Array.from(excecoes);
      }

      const response = await api.put(
        `/codinomes_colaborador/${codinome.id}/atribuir_produtos`,
        body,
      );
      const { status, message, total: totalAtribuido } = response.data;
      if (!status) throw message;

      enqueueSnackbar(
        `${totalAtribuido} produto(s) atribuído(s) ao codinome "${codinome.nome}" com sucesso!`,
        { variant: 'success' },
      );

      setCodinome(null);
      setModoSelecao(SELECAO_NENHUM);
      setExcecoes(new Set());
      setConfirmacaoAberta(false);
      setPage(0);
      await carregarProdutos(0);
    } catch (erros) {
      enqueueSnackbar(`${erros}`, { variant: 'error' });
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      aria-labelledby="distribuir-produtos-dialog-title"
      classes={{ paper: classes.rootDialogo }}
      className={classes.rootDialogo}
      fullWidth
      maxWidth="md"
      TransitionComponent={Transition}
    >
      <DialogTitle
        id="distribuir-produtos-dialog-title"
        onClose={handleCloseDialog}
        style={{ backgroundColor: '#009FD4', color: 'white' }}
      >
        Atribuir codinome aos produtos
      </DialogTitle>
      <DialogContent style={{ padding: '0px 36px 20px', margin: '0' }}>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginTop: '1em' }}
        >
          Selecione os produtos abaixo e escolha o codinome que será atribuído.
        </Typography>

        <Paper
          variant="outlined"
          style={{ padding: '16px', marginTop: '12px' }}
        >
          <AutoCompleteRemoto
            label="Codinome de destino"
            value={codinome}
            onChange={(value) => setCodinome(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="codinomes_colaborador"
            nested={[]}
            filters={{ status: STATUS_ATIVO, turno: TURNO_MANHA }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
            perPage={50}
          />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mt="0.75em"
            style={{ gap: '16px', flexWrap: 'wrap' }}
          >
            <Box>
              <Typography variant="body2">
                {totalSelecionados} produto(s) selecionado(s)
              </Typography>
              {modoSelecao === SELECAO_TODOS &&
                excecoes.size === 0 &&
                total > 0 && (
                  <Typography variant="body2" color="error">
                    Atenção: todos os {total} produtos encontrados estão
                    selecionados.
                  </Typography>
                )}
            </Box>
            <Box display="flex" alignItems="center" style={{ gap: '8px' }}>
              <Button
                size="small"
                variant="outlined"
                onClick={
                  totalSelecionados > 0 ? desmarcarTodos : selecionarTodos
                }
                disabled={total === 0}
              >
                {totalSelecionados > 0
                  ? 'Desmarcar todos'
                  : `Selecionar todos os ${total}`}
              </Button>
              <div className={classes.wrapper}>
                <Button
                  onClick={() => setConfirmacaoAberta(true)}
                  disabled={!codinome || totalSelecionados === 0 || salvando}
                  classes={{
                    root: classes.btnAtions,
                    disabled: classes.btnAtionsDisabled,
                  }}
                  variant="contained"
                  color="primary"
                >
                  {codinome ? `Atribuir ${totalSelecionados}` : 'Atribuir'}
                </Button>
                {salvando && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </Box>
          </Box>
        </Paper>

        <Divider style={{ margin: '16px 0' }} />

        <Paper variant="outlined" style={{ padding: '16px' }}>
          <Box display="flex" alignItems="center" style={{ gap: '16px' }}>
            <Box flex={1}>
              <TextInput
                label="Nome ou código do produto"
                value={nome}
                onChange={(event) => setNome(event.target.value)}
                handleKey={() => {}}
                handleEnter={() => {}}
                fullWidth
                margin="none"
              />
            </Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={(event) => setAnchorElFiltro(event.currentTarget)}
              disabled={filtrosAtivos.length === FILTROS_DISPONIVEIS.length}
            >
              Adicionar filtro
            </Button>
            <Menu
              anchorEl={anchorElFiltro}
              open={Boolean(anchorElFiltro)}
              onClose={() => setAnchorElFiltro(null)}
            >
              {FILTROS_DISPONIVEIS.filter(
                (filtro) => !filtrosAtivos.includes(filtro.key),
              ).map((filtro) => (
                <MenuItem
                  key={filtro.key}
                  onClick={() => adicionarFiltro(filtro.key)}
                >
                  {filtro.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {filtrosAtivos.length > 0 && (
            <Grid container spacing={2} style={{ marginTop: '8px' }}>
              {filtrosAtivos.map((key) => (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Box
                    display="flex"
                    alignItems="center"
                    style={{ gap: '4px' }}
                  >
                    <Box flex={1}>{renderCampoFiltro(key)}</Box>
                    <IconButton size="small" onClick={() => removerFiltro(key)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </Paper>

        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginTop: '16px' }}
        >
          {total} produto(s) encontrado(s)
        </Typography>

        <TableContainer
          component={Paper}
          variant="outlined"
          style={{ marginTop: '8px' }}
        >
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={todosSelecionadosNaPagina}
                    onChange={toggleTodosDaPagina}
                    disabled={produtos.length === 0}
                  />
                </TableCell>
                <TableCell style={{ fontWeight: 'bold', width: '100px' }}>
                  ID
                </TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Nome</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {carregando ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : produtos.length > 0 ? (
                produtos.map((produto) => (
                  <TableRow key={produto.id} hover>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isProdutoSelecionado(produto.id)}
                        onChange={() => toggleProduto(produto.id)}
                      />
                    </TableCell>
                    <TableCell>{produto.id}</TableCell>
                    <TableCell>{produto.nome}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    Nenhum produto sem codinome encontrado
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onChangePage={(_, newPage) => setPage(newPage)}
            rowsPerPage={PRODUTOS_PER_PAGE}
            rowsPerPageOptions={[]}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} de ${count}`
            }
          />
        </TableContainer>
      </DialogContent>

      <Dialog
        open={confirmacaoAberta}
        onClose={() => setConfirmacaoAberta(false)}
        aria-labelledby="confirmar-atribuir-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          id="confirmar-atribuir-dialog-title"
          onClose={() => setConfirmacaoAberta(false)}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          Confirmar atribuição
        </DialogTitle>
        <DialogContent style={{ padding: '20px 36px' }}>
          <Typography variant="body2">
            Você está prestes a atribuir o codinome &quot;
            {codinome ? codinome.nome : ''}&quot; para {totalSelecionados}{' '}
            produto(s). Esta ação afetará todos os produtos selecionados.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: '0px 36px 20px', margin: '0' }}>
          <Button onClick={() => setConfirmacaoAberta(false)}>Cancelar</Button>
          <div className={classes.wrapper}>
            <Button
              onClick={handleConfirmarAtribuir}
              disabled={salvando}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              Confirmar
            </Button>
            {salvando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
});

export default DialogoDistribuirProdutos;
